import { TAB_TITLE } from 'containers/Product/constants'
import { k8V2ContentfulMappings } from 'utils/productMaps'
import { toTitleCase } from 'utils/stringHelpers'

const normalizeTitle = title => title?.toLowerCase()

const getDisplayTitleMapping = internalTitle => {
  const normalizedInternalTitle = normalizeTitle(internalTitle)

  return k8V2ContentfulMappings.find(mapping =>
    normalizedInternalTitle?.includes(normalizeTitle(mapping?.displayTitle)),
  )
}

export const addDisplayTitlesToCourseTree = courseTree => {
  if (!courseTree || !courseTree.internalTitle) {
    return courseTree
  }

  const matchingMapping = getDisplayTitleMapping(courseTree.internalTitle)

  if (!matchingMapping) {
    return courseTree
  }

  return {
    ...courseTree,
    displayTitle: matchingMapping.displayTitle,
  }
}

/**
 * Processes a collection of course trees by converting object to array and adding display titles
 * @param {Object} courseTreeCollection - Object containing course trees as values
 * @returns {Array} Array of processed course trees with display titles added where matches are found
 */
export const processCourseTreeCollectionV2ToWorkWithV1CourseShapes = courseTreeCollection => {
  if (!courseTreeCollection || typeof courseTreeCollection !== 'object') {
    return []
  }
  return Object.values(courseTreeCollection).map(courseTree =>
    addDisplayTitlesToCourseTree(courseTree),
  )
}

export const getLessonPageViewModel = ({
  match,
  productName,
  productTabTitle,
}) => {
  const baseUrl = match?.url ?? ''
  const basePath = match?.path ?? baseUrl
  const productTitle = toTitleCase(
    `${productName?.replace(/-/g, ' ') ?? ''} Lessons`.trim(),
  )
  const withVerb = `${basePath}/:verb(preview|teach)`
  const tabTitle = [productTabTitle, TAB_TITLE].filter(Boolean).join(' | ')

  return {
    baseUrl,
    productTitle,
    tabTitle,
    withVerb,
  }
}
